import Add from "./components/icons/add.vue";

export const messages = {
  en: {
    PresentationMode: "Presentation mode",
    ResetPresentationGroups: "Reset to 2 lines",
    PresentationEmpty: "Add lyrics to this chapter to create presentation groups.",
    PresentationGroup: "Group",
    SplitPresentation: "Split",
    MergePresentation: "Merge",
    SplitPresentationAfter: "Start a new group after line {line}",
    MergePresentationGroups: "Merge groups {first} and {second}",
    PresentationBoundary: "Divider after group {group}",
    PresentationAfterLine: "After line {line}",
    PresentationGroupCount: "{count} presentation groups · Saved with Save changes",
    "Acoustic guitar": "Acoustic guitar",
    "Children's church": "Children's church",
    "Electric guitar": "Electric guitar",
    "Music director": "Music director",
    "Pre-chorus": "Pre-chorus",
    "Sound tech": "Sound tech",
    Accidental: "Accidental",
    DIYChord: "Build custom chord",
    Account: "Account",
    Add: "Add",
    AvailableToServe: "Available to serve",
    AvailableToServeCount: "{count} available to serve",
    NoUsersAvailableToServe: "No users are currently available to serve",
    Serving: "Serving",
    ServingCount: "{count} serving",
    NoUsersServing: "No users are currently serving",
    ViewAttendees: "View attendees",
    AttendeesCount: "Attendees ({count})",
    OnTeams: "On {teams}",
    NoTeams: "No teams",
    EveryoneWhoHasOfferedToServe: "Everyone who has offered to serve.",
    NoOneHasOfferedToServe: "No one has offered to serve yet.",
    EmailAlreadyExists: "An account with this e-mail already exists",
    PasswordTooShort: "Password should be at least 6 characters",
    NotTheMagicWord: "That wasn't the magic word",
    MissingPassword: "Password is missing",
    ReferenceDoesNotExist:
      "This reference does not exist. Please contact an admin.",
    AccountDoesNotExist: "This account does not exist with us",
    AddCommunion: "Add communion",
    AddElement: "Add element",
    AddFeature: "Add feature",
    Show: "Show",
    Adding: "Adding",
    Addition: "Addition",
    Address: "Address",
    AddLead: "Add lead",
    Added: "Added",
    Leadership: "Leadership",
    AddScheduleElement: "Add schedule element",
    AddSermon: "Add sermon",
    AddSkill: "Add skill",
    AddSong: "Add song",
    AddSongElementLabel: "Add a chapter",
    AddSongToSetlistMessage: 'Would you like to add "{title}" to the setlist?',
    AddText: "Add text",
    AddTextElement: "Add text element",
    Admin: "Admin",
    Announcements: "Announcements",
    Apply: "Apply",
    April: "April",
    areAttending: "are attending",
    Assignment: "Assignment",
    at: "at",
    Attendee: "Attendee",
    Attendees: "Attendees",
    AttendeesNotIn: 'Attendees outside "{team}"',
    NoAttendeesFromTeam: 'We found no attendees from the "{team}" team',
    NoAssignedTeamMembers: "No assigned team members are attending",
    Attending: "Attending",
    ThereWasAnErrorSettingYourAttendance:
      "There was an error setting your attendance",
    August: "August",
    Author: "Author",
    Back: "Back",
    Background: "Background",
    BackToTheEvent: "Back to the event",
    Banned: "Banned",
    Bars: "Bars",
    Bass: "Bass",
    BroadcastChapterUpdates: "Broadcast chapter updates",
    BroadcastChapterUpdatesDescription:
      "Set the current song and chapter for everyone listening.",
    Bridge: "Bridge",
    Calendar: "Calendar",
    CalendarWelcomeMessage: "Here is an overview of events in {month}",
    Cancel: "Cancel",
    YouAreOn: "You are on",
    ChangeKey: "Change key",
    Scripture: "Scripture",
    changePassword: "Change password",
    ChangesWereDetected: "Changes were detected",
    ChapterSync: "Chapter sync",
    ChangeTime: "Change time",
    ChangeDuration: "Change duration",
    AllTeams: "All teams",
    Choose: "Choose",
    ChooseMonth: "Choose month",
    ChooseSong: "Choose song",
    ChooseSkill: "Choose skill",
    ChooseTeam: "Choose a team",
    ChordEditor: "Chord editor",
    Chords: "Chords",
    Chorus: "Chorus",
    ClickHere: "Click here",
    Close: "Close",
    Color: "Color",
    Communion: "Communion",
    Confirm: "Confirm",
    ConfirmDeleteSongDescription: "Type the title of the song to confirm.",
    Control: "Control",
    Create: "Create",
    CreateEvent: "Create event",
    CreateEventForDate: "Create event for {date}",
    CreateSong: "Create song",
    SongWasCreated: "The song was created",
    Open: "Open",
    CreateTeam: "Create team",
    CreatingEvent: "Creating event",
    Danish: "Danish",
    English: "English",
    Date: "Date",
    December: "December",
    Delete: "Delete",
    deleteAccount: "Delete account",
    DeleteEvent: "Delete event",
    SelfAssignable: "Self assignable",
    DeleteTeamMessage: "Are you sure you want to delete {team}",
    DeleteUser: "Delete user",
    Description: "Description",
    Drums: "Drums",
    Edit: "Edit",
    EditOriginalSong: "Edit original song",
    EndTime: "Ends at",
    Event: "Event",
    Events: "Events",
    EventSettings: "Event settings",
    Extension: "Extension",
    Extra: "Extra",
    Feature: "Feature",
    February: "February",
    Files: "Files",
    UploadFile: "Upload file",
    NoFilesUploadedYet: "No files uploaded yet",
    OnlyPdfOrImageFiles: "Only PDF or image files are allowed",
    FailedToUploadEventFile: "Failed to upload file",
    FailedToDeleteEventFile: "Failed to delete file",
    OnlyAdminsCanUploadFiles: "Only admins can upload files",
    AddComment: "Add comment",
    WriteAComment: "Write a comment",
    NoCommentsYet: "No comments yet",
    FailedToAddComment: "Failed to add comment",
    FailedToLoadScheduleItem:
      "This schedule item could not be loaded. Please try again.",
    FailedToLoadSong: "This song could not be loaded. Please try again.",
    FailedToLoadSongs: "The songs could not be loaded. Please try again.",
    FilterSongs: "Filter songs",
    AllLanguages: "All",
    LanguageUnknown: "Unknown",
    SearchAuthors: "Search authors",
    NoAuthorsFound: "No authors found",
    ClearFilters: "Clear filters",
    RemoveFilter: "Remove filter",
    SongCount: "no songs | 1 song | {count} songs",
    NoSongsMatchFilters: "No songs match these filters",
    FailedToLoadScheduleTemplate: "Failed to load schedule template",
    MaxProfileImageSizeExceeded: "Image must be 500 KB or smaller",
    FRI: "FRI",
    AllSignupFieldsRequired: "Please fill in all fields to create an account",
    FullName: "Full name",
    FullSetList: "Full set list",
    GoodAfternoon: "Good afternoon",
    goodbye: "Goodbye",
    GoodEvening: "Good evening",
    GoodMorning: "Good morning",
    GoodNight: "Good night",
    TodayOnTeam: "You are on {team} today",
    hello: "Hello",
    HideChords: "Hide chords",
    Hosts: "Hosts",
    Image: "Image",
    imAttending: "I'm attending",
    imNotAttending: "I'm not attending",
    Insert: "Insert",
    InsertTitle: "Insert title",
    InsertYourNotes: "Insert your notes",
    Interlude: "Interlude",
    Intro: "Intro",
    isAttending: "is attending",
    isRequired: "is required",
    January: "January",
    July: "July",
    June: "June",
    Key: "Key",
    Keys: "Keys",
    Language: "Language",
    Listen: "Listen",
    ListenForChapterUpdates: "Listen for chapter updates",
    ListenForChapterUpdatesDescription:
      "Follow the chapter selected by the broadcaster.",
    ListIsEmpty: "List is empty",
    LiveEvent: "Live event",
    LiveUpdates: "Live updates",
    logOut: "Log out",
    Major: "Major",
    March: "March",
    May: "May",
    MDControls: "MD Controls",
    Moderator: "Moderator",
    MON: "MON",
    MoveDown: "Move down",
    MoveUp: "Move up",
    Multimedia: "Multimedia",
    Name: "Name",
    newPassword: "New password",
    NewPassword: "New password",
    newPasswordRepeat: "Repeat new password",
    Next: "Next",
    NextEvent: "Upcoming event",
    Offering: "Offering",
    OrLoadATemplate: "Or load a template",
    FontSize: "Font size",
    Comments: "Comments",
    Chat: "Chat",
    Comment: "Comment",
    ForgotPassword: "if you forgot your password",
    EnterEmailForReset: "Please enter your e-mail first",
    ResetPasswordEmailSent:
      "If this e-mail exists, we have sent you a reset link",
    SharedComment: "Shared comment",
    PersonalComment: "Personal comment",
    AddCommentsVisibleToEveryone: "Add comments visible to everyone",
    AddCommentsOnlyForYou: "Add comments only for you",
    ArrangementComment: "Comment on this play",
    ArrangementCommentDescription:
      "Shown at this place in the arrangement only, not wherever the chapter is played.",
    ArrangementCommentPlaceholder: "E.g. drums only",
    None: "None",
    NoSlides: "No slides",
    NotAttending: "Not attending",
    Notes: "Notes",
    NoThanks: "No thanks",
    NoUpcomingEvents: "There are no upcoming events scheduled",
    November: "November",
    NoTeamsAdded: "No teams added",
    NobodyYet: "Nobody yet",
    October: "October",
    on: "on",
    OnTheTeam: "Todays team",
    Optional: "Optional",
    Options: "Options",
    PlatformOrganisations: "All organisations",
    PlatformOnlyMasters: "Only the platform's owners can see this page.",
    PlatformCreateOrganisation: "Create organisation",
    PlatformReferenceHint: "The number members join by. It cannot be changed afterwards.",
    PlatformReferenceTaken: "Another organisation already has this reference.",
    PlatformReferenceInvalid: "The reference must be a whole number above 0.",
    PlatformSwitchTo: "Go to",
    PlatformYouAreHere: "You are here",
    Organisation: "Organisation",
    OrganisationJoin: "Join another organisation",
    OrganisationJoinHint: "Enter its reference number. You join as a user; an admin there can give you more.",
    OrganisationSwitchFailed: "Could not switch organisation",
    OrganisationRemoveUser: "Remove from organisation",
    OrganisationRemoveUserDetail: "{name} belongs to other organisations too, so they are only removed from this one.",
    OrganisationIcon: "Organisation icon",
    OrganisationSettings: "Organisation settings",
    Or: "Or",
    Order: "Order",
    Outro: "Outro",
    Password: "Password",
    Percussion: "Percussion",
    Phone: "Phone",
    PhoneNumber: "Phone number",
    Preacher: "Preacher",
    Preaching: "Preaching",
    PreferrablyInEnglish: "",
    PreferredLanguage: "Preferred language",
    PreviousKey: "Previous key",
    PreviousLeadSongKeyMessage:
      "{lead} previously led {song} in {key}.",
    President: "President",
    Private: "Private",
    Profile: "My profile",
    Public: "Public",
    Remove: "Remove",
    RemoveScheduleItem: "Remove entry",
    RemoveScheduleSermon: "Remove sermon",
    RemoveScheduleSong: "Remove song",
    RemoveScheduleSongCompleted: "The song has been removed",
    RemoveScheduleSongDescription: "Are you sure you want to remove this song?",
    Repertoire: "Repertoire",
    resetDisplayName: "Reset display name",
    Role: "Role",
    Roles: "Roles",
    SAT: "SAT",
    Save: "Save",
    SaveChanges: "Save changes",
    SaveKey: "Save key",
    Schedule: "Schedule",
    ScheduleTemplate: "Schedule template",
    ScheduleIsEmpty: "There is no schedule",
    ScriptualPassage: "Scriptual passage",
    SearchForASong: "Search for a song",
    SearchForAUser: "Search for a user",
    SearchForASongAuthorOrType: "Search for a title, author or type",
    Select: "Select",
    SelectTeams: "Select teams",
    SelectType: "Select type",
    September: "September",
    Sermon: "Sermon",
    Settings: "Settings",
    ShowChords: "Show chords",
    SignIn: "Sign in",
    SignUp: "Sign up",
    Skills: "Skills",
    SkillsFor: "Skills for",
    Song: "Song",
    SongIsCreated: "Song has been created",
    Songs: "Songs",
    Sound: "Sound",
    speaker: "Speaker",
    Stop: "Stop",
    Speaker: "Speaker",
    Started: "Started",
    StartTime: "Starts at",
    Reference: "Reference",
    Submit: "Submit",
    subtitle: "Subtitle",
    SUN: "SUN",
    SuperAdmin: "SuperAdmin",
    Team: "Team",
    Teams: "Teams",
    TeamsAndUsers: "Teams & users",
    TeamsFor: "Teams for",
    Tempo: "Tempo",
    Text: "Text",
    TextSize: "Text size",
    TheKeyHasBeenChangedTo: "The key has been changed to",
    ThereAreNoAttendees: "There are no attendees",
    THU: "THU",
    Time: "Time",
    TimeSignature: "Time signature",
    Modulation: "Modulation",
    TheScheduleStartsIn: "The schedule starts in",
    TryAgain: "Try again",
    Length: "Length",
    Hour: "Hour",
    Hours: "Hours",
    Minute: "Minute",
    Minutes: "Minutes",
    Second: "Second",
    Seconds: "Seconds",
    Sec: "Sec",
    Title: "Title",
    to: "to",
    toCreateAnAccount: "to create an account",
    toLogin: "to log in",
    Translation: "Translation",
    Transpose: "Transpose",
    TUE: "TUE",
    Type: "Type",
    Upcoming: "Upcoming",
    Update: "Update",
    User: "User",
    Users: "Users",
    UserType: "User type",
    Verse: "Verse",
    Quality: "Quality",
    Minor: "Minor",
    Augmented: "Augmented",
    Diminished: "Diminished",
    Vocals: "Vocals",
    WED: "WED",
    Welcome: "Welcome",
    WhatShouldUserDo: "What is {user} doing?",
    whoIsComing: "Who is coming?",
    SignupFailed: "Signup failed",
    LoginFailed: "Login failed",
    EmailIsNotValid: "This e-mail is not valid",
    TooManyRequestsTryLater: "Too many attempts. Please try again later",
    NetworkRequestFailed: "Network error. Please check your connection",
    MissingPermissions: "Missing permissions",
    with: "with",
    MaxUsersOnEvent: "Max users",
    Join: "Join",
    Worship: "Worship",
    WaitingForTranslation: "Waiting for translation...",
    TranslationConnecting: "Connecting...",
    TranslationPermissionDenied: "Access to this translation was denied. Please ask the organiser to check the translation database permissions.",
    TranslationConnectionFailed: "Unable to connect to the translation. Check your connection and try again.",
    TranslationRetry: "Try again",
    HideFromEvents: "Hide from events",
    CountAreNotAttending: "{count} are not attending",
    CountAreAttending: "{count} are attending",
    NobodysAttending: "Nobody is attending",
    YouAreAvailableToServe: "You are available to serve",
    WouldYouLikeToApplyThisKey: "Would you like to apply this change?",
    YouAndOneOtherAreAttending: "You and 1 other are attending",
    YouAndOneOtherAreNotAttending: "You and 1 other are not attending",
    YouAndOthersAreAttending: "You and {count} others are attending",
    YouAndOthersAreNotAttending: "You and {count} others are not attending",
    YouAreNotAttending: "You are not attending",
    YouAreTheOnlyAttendee: "You are the only attendee",
    Prayer: "Prayer",
    ScheduleTemplates: "Schedule templates",
    ScheduleTemplatesDescription: "Templates can be loaded into an event with an empty schedule.",
    NewTemplate: "New template",
    StartFrom: "Start from",
    ScheduleElements: "Elements",
    TemplateHasNoElements: "This template has no elements yet.",
    Total: "Total",
    DeleteTemplate: "Delete template",
    DeleteTemplateMessage: "Delete the template “{template}”? Events that already used it are not affected.",
    TemplateSaved: "Template saved",
    FailedToSaveTemplate: "Failed to save template",
    FailedToDeleteTemplate: "Failed to delete template",
    FailedToLoadTemplates: "Failed to load templates",
    NoScheduleTemplates: "Your organisation has no templates yet. Create one to load it into events with an empty schedule.",
    ElementCount: "no elements | 1 element | {count} elements",
    ManageTemplates: "Manage templates",
    TemplateTitleTaken: "Another template already has this title.",
    Subject: "Subject",
    OfferingSubjectPlaceholder: "What the offering is for",
    MobilePayNumber: "MobilePay number",
    DefaultMobilePayNumber: "Default MobilePay number",
    DefaultMobilePayNumberHint:
      "Filled in on this template's offerings when it is loaded into an event.",
    CopyOfTemplate: "{title} (copy)",
    CreateScheduleTemplate: "Create a schedule template",
    ElementType: "Type",
    Move: "Move",
    Slides: "Slides",
    SlidesLibrary: "Library",
    CreateSlides: "Create slides",
    EditSlides: "Edit slides",
    ChooseSlides: "Choose slides",
    SlidesSelected: "Selected",
    NoSlideshowsYet:
      "Your organisation has no slides yet. Create a set to add it to the schedule.",
    SlideCount: "no slides | 1 slide | {count} slides",
    SlideNumber: "Slide {number}",
    AddPhotos: "Add photos",
    SearchPhotos: "Search photos",
    PhotosHint: "Click a photo to add it as a slide.",
    NoPhotosYet:
      "No photos yet. Add some to build slides from them; they are kept here to use again.",
    NoPhotosMatch: "No photos match “{search}”.",
    NoSlidesYet: "No slides yet. Click a photo above to add it.",
    SlidesHint: "Drag a slide to move it.",
    SlideFilesSkipped:
      "Some files were left out: only images of 10 MB or less can be added.",
    Transition: "Transition",
    TransitionFade: "Fade",
    TransitionSlide: "Slide",
    TransitionZoom: "Zoom",
    SaveAndAddToSchedule: "Save and add to schedule",
    UploadingPhotos: "Uploading {done} of {total}",
    FailedToUploadPhotos: "Some photos could not be uploaded",
    SlidesSaved: "Slides saved",
    FailedToSaveSlides: "Failed to save slides",
    FailedToLoadSlides: "Failed to load slides",
    FailedToDeleteSlides: "Failed to delete slides",
    FailedToAddSlides: "Failed to add slides to the schedule",
    DeleteSlides: "Delete slides",
    DeleteSlidesMessage:
      "Delete “{title}” from the library? Schedule items showing it are left without slides. Its photos are kept.",
    AddPhotoToSlides: "Add {name} to the slides",
    FailedToLoadPhotos: "Failed to load the photos",
    DeletePhoto: "Delete photo",
    DeletePhotoMessage:
      "Delete “{name}” from your photos? This cannot be undone.",
    PhotoInUse:
      "This photo is used in {titles}, so it cannot be deleted. Take it out of those slides first.",
    FailedToDeletePhoto: "Failed to delete the photo",
    AddImageSlides: "Add image slides",
    ChangeImage: "Change image",
    ImageSlidesHint: "Click photos to choose them, in the order they should come.",
    AddSelectedSlides: "Add | Add 1 slide | Add {count} slides",
    OriginalVersion: "Original",
    NewVersion: "New version",
    NewVersionDescription:
      "Starts as a copy of the version you have open. Title and author stay shared; lyrics, chords and chapters are its own.",
    VersionName: "Version name",
    VersionNamePlaceholder: "E.g. Acoustic",
    SharedByAllVersions: "Title and author are shared by all versions.",
    SaveChangesToSwitchVersion: "Save or cancel your changes first",
    ChooseVersion: "Choose version",
    DeleteVersion: "Delete version",
    ConfirmDeleteVersionDescription:
      "Delete the version “{name}”? The original and any other versions are kept.",
    DeleteSongVersionsWarning:
      "Its other versions ({count}) are deleted with it.",
  },
  da: {
    PresentationMode: "Præsentationstilstand",
    ResetPresentationGroups: "Nulstil til 2 linjer",
    PresentationEmpty: "Tilføj sangtekst til dette afsnit for at oprette præsentationsgrupper.",
    PresentationGroup: "Gruppe",
    SplitPresentation: "Opdel",
    MergePresentation: "Saml",
    SplitPresentationAfter: "Start en ny gruppe efter linje {line}",
    MergePresentationGroups: "Saml gruppe {first} og {second}",
    PresentationBoundary: "Skillelinje efter gruppe {group}",
    PresentationAfterLine: "Efter linje {line}",
    PresentationGroupCount: "{count} præsentationsgrupper · Gemmes med Gem ændringer",
    "Acoustic guitar": "Akustisk guitar",
    "Children's church": "Børnekirke",
    "Electric guitar": "El. guitar",
    "Music director": "Musisk leder",
    "Pre-chorus": "Pre-chorus",
    "Sound tech": "Lyd",
    Accidental: "Fortegn",
    Prayer: "Bøn",
    DIYChord: "Byg-selv akkord",
    Quality: "Kvalitet",
    Account: "Konto",
    Join: "Deltag",
    Add: "Tilføj",
    MaxUsersOnEvent: "Maks. antal brugere",
    SelfAssignable: "Egen tilmelding",
    AvailableToServe: "Jeg kan tjene med",
    AvailableToServeCount: "{count} kan tjene",
    NoUsersAvailableToServe: "Ingen har meldt sig som ledige til tjeneste",
    Serving: "Tjener med",
    ServingCount: "{count} tjener med",
    NoUsersServing: "Ingen tjener med endnu",
    ViewAttendees: "Se deltagere",
    AttendeesCount: "Deltagere ({count})",
    OnTeams: "På {teams}",
    NoTeams: "Ingen teams",
    EveryoneWhoHasOfferedToServe: "Alle der har meldt sig til at tjene med.",
    NoOneHasOfferedToServe: "Ingen har meldt sig til at tjene med endnu.",
    EmailAlreadyExists: "En konto med denne e-mail eksisterer allerede",
    PasswordTooShort: "Adgangskoden skal have en længde på min. 6 tegn",
    NotTheMagicWord: "Det var ikke det hemmelige kodeord",
    MissingPassword: "Adgangskode mangler",
    ReferenceDoesNotExist:
      "Denne reference findes ikke. Kontakt en administrator.",
    AccountDoesNotExist: "Denne konto eksisterer ikke hos os",
    MissingPermissions: "Ingen rettigheder",
    AddCommunion: "Tilføj nadver",
    AddElement: "Tilføj punkt",
    AddFeature: "Tilføj indslag",
    Added: "Tilføjet",
    Show: "Vis",
    Adding: "Tilføjer",
    Addition: "Tilføjelse",
    Address: "Adresse",
    AddLead: "Tilføj leder",
    AddSermon: "Tilføj prædiken",
    AddSkill: "Tilføj skill",
    AddSong: "Tilføj sang",
    AddSongElementLabel: "Tilføj kapitel",
    AddSongToSetlistMessage: 'Vil du tilføje "{title}" til sætlisten?',
    AddText: "Tilføj tekst",
    AddTextElement: "Tilføj tekst element",
    Admin: "Admin",
    Announcements: "Mødeledelse",
    April: "April",
    areAttending: "kommer",
    Assignment: "Opgave",
    at: "kl.",
    Attendee: "Deltager",
    Attendees: "Deltagere",
    AttendeesNotIn: 'Deltagere udenfor "{team}"',
    NoAttendeesFromTeam: 'Vi fandt ingen deltagere fra "{team}" teamet',
    NoAssignedTeamMembers: "Ingen tildelte teammedlemmer kommer",
    Attending: "Kommer",
    August: "August",
    Author: "Forfatter",
    Back: "Tilbage",
    Background: "Baggrund",
    BackToTheEvent: "Tilbage til eventet",
    Banned: "Udelukket",
    Bars: "Takter",
    Bass: "Bas",
    Leadership: "Ledelse",
    AddScheduleElement: "Tilføj program punkt",
    BroadcastChapterUpdates: "Broadcast kapitelopdateringer",
    BroadcastChapterUpdatesDescription:
      "Sæt den aktuelle sang og det aktuelle kapitel for alle, der følger med.",
    Bridge: "Bro",
    Calendar: "Kalender",
    CalendarWelcomeMessage: "Her er en oversigt over begivenheder i {month}.",
    Cancel: "Fortryd",
    YouAreOn: "Du er på",
    HideFromEvents: "Skjul fra begivenheder",
    ChangeKey: "Skift toneart",
    changePassword: "Skift adgangskode",
    ChangesWereDetected: "Der er foretaget ændringer",
    ChapterSync: "Kapitel sync",
    ChangeTime: "Skift tidspunkt",
    ChangeDuration: "Skift varighed",
    AllTeams: "Alle teams",
    Choose: "Vælg",
    ChooseMonth: "Vælg måned",
    ChooseSong: "Vælg sang",
    ChooseSkill: "Vælg skill",
    ChooseTeam: "Vælg team",
    ChordEditor: "Akkord editor",
    Chords: "Akkorder",
    Chorus: "Omkvæd",
    ClickHere: "Tryk her",
    Close: "Luk",
    Color: "Farve",
    Communion: "Nadver",
    Confirm: "Bekræft",
    ConfirmDeleteSongDescription: "Indtast sangens titel, og bekræft sletning.",
    Control: "Kontrol",
    Create: "Opret",
    CreateEvent: "Opret begivenhed",
    CreateEventForDate: "Opret begivenhed for {date}",
    CreateSong: "Opret sang",
    SongWasCreated: "Sangen blev oprettet",
    Open: "Åbn",
    CreateTeam: "Opret team",
    CreatingEvent: "Opretter begivenhed",
    Danish: "Dansk",
    English: "Engelsk",
    Date: "Dato",
    December: "December",
    Delete: "Slet",
    deleteAccount: "Slet konto",
    DeleteEvent: "Slet begivenhed",
    DeleteTeamMessage: "Er du sikker på du ønsker at slette {team}",
    DeleteUser: "Slet bruger",
    Description: "Beskrivelse",
    Drums: "Trommer",
    Edit: "Redigér",
    EditOriginalSong: "Redigér original sang",
    EndTime: "Slutter",
    Event: "Begivenhed",
    Events: "Begivenheder",
    EventSettings: "Indstillinger for begivenheden",
    Extension: "Udvidelse",
    Extra: "Ekstra",
    Feature: "Indslag",
    February: "Februar",
    Files: "Filer",
    UploadFile: "Upload fil",
    NoFilesUploadedYet: "Ingen filer uploadet endnu",
    OnlyPdfOrImageFiles: "Kun PDF- eller billedfiler er tilladt",
    FailedToUploadEventFile: "Kunne ikke uploade fil",
    FailedToDeleteEventFile: "Kunne ikke slette fil",
    OnlyAdminsCanUploadFiles: "Kun administratorer kan uploade filer",
    AddComment: "Tilføj kommentar",
    WriteAComment: "Skriv en kommentar",
    NoCommentsYet: "Ingen kommentarer endnu",
    FailedToAddComment: "Kunne ikke tilføje kommentar",
    FailedToLoadScheduleItem:
      "Dette programpunkt kunne ikke indlæses. Prøv igen.",
    FailedToLoadSong: "Denne sang kunne ikke indlæses. Prøv igen.",
    FailedToLoadSongs: "Sangene kunne ikke indlæses. Prøv igen.",
    FilterSongs: "Filtrér sange",
    AllLanguages: "Alle",
    LanguageUnknown: "Ukendt",
    SearchAuthors: "Søg efter forfatter",
    NoAuthorsFound: "Ingen forfattere fundet",
    ClearFilters: "Ryd filtre",
    RemoveFilter: "Fjern filter",
    SongCount: "ingen sange | 1 sang | {count} sange",
    NoSongsMatchFilters: "Ingen sange passer til filtrene",
    FailedToLoadScheduleTemplate: "Kunne ikke indlæse programskabelon",
    MaxProfileImageSizeExceeded: "Billedet skal være maks. 500 KB",
    FRI: "FRE",
    AllSignupFieldsRequired: "Udfyld alle felter for at oprette en konto",
    FullName: "Fulde navn",
    Reference: "Reference",
    FullSetList: "Alle sange i sætlisten",
    GoodAfternoon: "God eftermiddag",
    goodbye: "Farvel",
    GoodEvening: "God aften",
    GoodMorning: "God morgen",
    GoodNight: "Godnat",
    TodayOnTeam: "Du er på {team} i dag",
    hello: "Halløjsa",
    HideChords: "Skjul akkorder",
    Hosts: "Værtsteam",
    Image: "Billede",
    imAttending: "Jeg kommer",
    imNotAttending: "Jeg kommer ikke",
    Insert: "Indsæt",
    InsertTitle: "Indsæt titel",
    InsertYourNotes: "Indsæt noter her",
    Interlude: "Interlude",
    Intro: "Intro",
    isAttending: "kommer",
    isRequired: "er påkrævet",
    January: "Januar",
    July: "Juli",
    June: "Juni",
    Key: "Toneart",
    Keys: "Klaver",
    Language: "Sprog",
    Listen: "Følg med",
    ListenForChapterUpdates: "Følg kapitelopdateringer",
    ListenForChapterUpdatesDescription:
      "Følg det kapitel, som broadcasteren vælger.",
    ListIsEmpty: "Listen er tom",
    LiveEvent: "Live event",
    LiveUpdates: "Live opdatering",
    logOut: "Log ud",
    Major: "Dur",
    Minor: "Mol",
    Augmented: "Forhøjet",
    Diminished: "Formindsket",
    March: "Marts",
    May: "Maj",
    MDControls: "MD kontrol",
    Moderator: "Moderator",
    MON: "MAN",
    MoveDown: "Flyt ned",
    MoveUp: "Flyt op",
    Multimedia: "Multimedie",
    Name: "Navn",
    newPassword: "Nyt kodeord",
    NewPassword: "Nyt kodeord",
    newPasswordRepeat: "Gentag nyt kodeord",
    Next: "Næste",
    NextEvent: "Kommende begivenhed",
    Offering: "Kollekt",
    OrLoadATemplate: "Eller indlæs en skabelon",
    FontSize: "Tekst str.",
    Comments: "Kommentarer",
    Chat: "Chat",
    Comment: "Kommentar",
    ForgotPassword: "hvis du har glemt dit kodeord",
    EnterEmailForReset: "Indtast venligst din e-mail først",
    ResetPasswordEmailSent:
      "Hvis e-mailen findes, har vi sendt dig et nulstillingslink",
    SharedComment: "Fælles kommentar",
    PersonalComment: "Personlig kommentar",
    AddCommentsVisibleToEveryone: "Tilføj kommentar for alle",
    AddCommentsOnlyForYou: "Tilføj kommentar kun for dig",
    ArrangementComment: "Kommentar til denne gang",
    ArrangementCommentDescription:
      "Vises kun på dette sted i arrangementet, ikke hver gang afsnittet spilles.",
    ArrangementCommentPlaceholder: "F.eks. kun trommer",
    None: "Ingen",
    NoSlides: "Ingen slides",
    NotAttending: "Kommer ikke",
    ThereWasAnErrorSettingYourAttendance:
      "Der opstod en fejl ved opdatering af din deltagelse",
    Notes: "Noter",
    NoThanks: "Nej tak",
    NoUpcomingEvents: "Der er ingen kommende begivenheder",
    November: "November",
    NoTeamsAdded: "Ingen teams er tilføjet",
    NobodyYet: "Ingen endnu",
    October: "Oktober",
    on: "på",
    OnTheTeam: "Dagens hold",
    Optional: "Ikke påkrævet",
    Options: "Muligheder",
    PlatformOrganisations: "Alle organisationer",
    PlatformOnlyMasters: "Kun platformens ejere kan se denne side.",
    PlatformCreateOrganisation: "Opret organisation",
    PlatformReferenceHint: "Nummeret medlemmer melder sig ind med. Det kan ikke ændres bagefter.",
    PlatformReferenceTaken: "En anden organisation har allerede dette referencenummer.",
    PlatformReferenceInvalid: "Referencenummeret skal være et helt tal over 0.",
    PlatformSwitchTo: "Gå hertil",
    PlatformYouAreHere: "Du er her",
    Organisation: "Organisation",
    OrganisationJoin: "Bliv medlem af en anden organisation",
    OrganisationJoinHint: "Skriv dens referencenummer. Du bliver medlem som bruger; en admin der kan give dig mere.",
    OrganisationSwitchFailed: "Kunne ikke skifte organisation",
    OrganisationRemoveUser: "Fjern fra organisationen",
    OrganisationRemoveUserDetail: "{name} hører også til andre organisationer, så de fjernes kun fra denne.",
    OrganisationIcon: "Organisationens ikon",
    OrganisationSettings: "Organisationsindstillinger",
    Or: "Eller",
    Order: "Rækkefølge",
    Outro: "Outro",
    Password: "Adgangskode",
    Percussion: "Percussion",
    Phone: "Telefon",
    PhoneNumber: "Telefon nummer",
    Preacher: "Prædikant",
    Preaching: "Forkyndelse",
    PreferrablyInEnglish: "Vi anbefalder at skrive titler på engelsk",
    PreferredLanguage: "Foretrukne sprog",
    PreviousKey: "Tidligere toneart",
    PreviousLeadSongKeyMessage:
      "{lead} sang tidligere {song} i {key}.",
    President: "Præsident",
    Private: "Privat",
    Profile: "Min profil",
    Public: "Offentlig",
    Remove: "Fjern",
    RemoveScheduleItem: "Fjern punkt",
    RemoveScheduleSermon: "Fjern prædiken",
    RemoveScheduleSong: "Fjern sang",
    RemoveScheduleSongCompleted: "Sangen er fjernet fra dette sæt",
    RemoveScheduleSongDescription:
      "Er du sikker på du ønsker at fjerne denne sang?",
    Repertoire: "Repertoire",
    resetDisplayName: "Nulstil kaldenavn",
    Role: "Rolle",
    Roles: "Roller",
    SAT: "LØR",
    Save: "Gem",
    SaveChanges: "Gem ændringer",
    SaveKey: "Gem toneart",
    Schedule: "Program",
    ScheduleTemplate: "Programskabelon",
    ScheduleIsEmpty: "Der er intet program",
    ScriptualPassage: "Skriftsted",
    SearchForASong: "Søg efter sang",
    SearchForAUser: "Søg efter bruger",
    SearchForASongAuthorOrType: "Søg efter titel, forfatter eller type",
    Select: "Vælg",
    SelectTeams: "Vælg teams",
    SelectType: "Vælg type",
    September: "September",
    Sermon: "Prædiken",
    Settings: "Indstillinger",
    ShowChords: "Vis akkorder",
    SignIn: "Log ind",
    SignUp: "Registrér",
    Skills: "Skills",
    SkillsFor: "Skills for",
    Song: "Sang",
    SongIsCreated: "Sangen er oprettet",
    Songs: "Sange",
    Sound: "Lyd",
    speaker: "Taler",
    Stop: "Stop",
    Speaker: "Taler",
    Started: "Startede",
    StartTime: "Starter",
    Submit: "Indsend",
    subtitle: "Note",
    SUN: "SØN",
    SuperAdmin: "SuperAdmin",
    Team: "Team",
    Teams: "Teams",
    TeamsAndUsers: "Teams & brugere",
    TeamsFor: "Teams for",
    Tempo: "Tempo",
    Text: "Tekst",
    TextSize: "Størrelse",
    TheKeyHasBeenChangedTo: "Toneart er ændret til",
    ThereAreNoAttendees: "Der er ingen deltagende",
    THU: "TOR",
    Time: "Tidspunkt",
    TimeSignature: "Taktart",
    Modulation: "Modulation",
    TheScheduleStartsIn: "Programmet starter om",
    TryAgain: "Prøv igen",
    Length: "Længde",
    Hour: "Time",
    Hours: "Timer",
    Minute: "Minut",
    Minutes: "Minutter",
    Second: "Sekund",
    Seconds: "Sekunder",
    Sec: "Sek",
    Title: "Titel",
    to: "til",
    toCreateAnAccount: "for at oprette en bruger",
    toLogin: "for at logge ind",
    Translation: "Oversættelse",
    Transpose: "Transponér",
    TUE: "TIR",
    Type: "Indtast",
    Upcoming: "Kommende",
    Update: "Opdatér",
    User: "Bruger",
    Users: "Brugere",
    UserType: "Bruger type",
    Verse: "Vers",
    Vocals: "Vokal",
    WED: "ONS",
    Welcome: "Velkommen",
    WhatShouldUserDo: "Hvad skal {user} lave?",
    whoIsComing: "Hvem kommer?",
    SignupFailed: "Fejl i registrering",
    LoginFailed: "Login mislykkedes",
    EmailIsNotValid: "Denne e-mail er ikke gyldig",
    TooManyRequestsTryLater: "For mange forsøg. Prøv igen senere",
    NetworkRequestFailed: "Netværksfejl. Tjek din forbindelse",
    with: "med",
    WaitingForTranslation: "Venter på oversættelse...",
    TranslationConnecting: "Opretter forbindelse...",
    TranslationPermissionDenied: "Adgang til oversættelsen blev afvist. Bed arrangøren om at kontrollere adgangsrettighederne til oversættelsesdatabasen.",
    TranslationConnectionFailed: "Kunne ikke oprette forbindelse til oversættelsen. Kontrollér din forbindelse, og prøv igen.",
    TranslationRetry: "Prøv igen",
    Worship: "Lovsang",
    CountAreNotAttending: "{count} kommer ikke",
    Scripture: "Skriftsted",
    CountAreAttending: "{count} kommer",
    NobodysAttending: "Ingen kommer",
    YouAreAvailableToServe: "Du er ledig til tjeneste",
    WouldYouLikeToApplyThisKey: "Vil du skifte til denne toneart?",
    YouAndOneOtherAreAttending: "Du og én anden kommer",
    YouAndOneOtherAreNotAttending: "Du og én anden kommer ikke",
    YouAndOthersAreAttending: "Du og {count} andre kommer",
    YouAreNotAttending: "Du kommer ikke",
    YouAreTheOnlyAttendee: "Kun du kommer",
    ScheduleTemplates: "Programskabeloner",
    ScheduleTemplatesDescription: "Skabeloner kan indlæses i en begivenhed med et tomt program.",
    NewTemplate: "Ny skabelon",
    StartFrom: "Start fra",
    ScheduleElements: "Elementer",
    TemplateHasNoElements: "Skabelonen har ingen elementer endnu.",
    Total: "I alt",
    DeleteTemplate: "Slet skabelon",
    DeleteTemplateMessage: "Slet skabelonen “{template}”? Begivenheder, der allerede har brugt den, påvirkes ikke.",
    TemplateSaved: "Skabelon gemt",
    FailedToSaveTemplate: "Kunne ikke gemme skabelonen",
    FailedToDeleteTemplate: "Kunne ikke slette skabelonen",
    FailedToLoadTemplates: "Kunne ikke indlæse skabeloner",
    NoScheduleTemplates: "Jeres organisation har ingen skabeloner endnu. Opret en for at kunne indlæse den i begivenheder med et tomt program.",
    ElementCount: "ingen elementer | 1 element | {count} elementer",
    ManageTemplates: "Administrér skabeloner",
    TemplateTitleTaken: "En anden skabelon har allerede denne titel.",
    Subject: "Formål",
    OfferingSubjectPlaceholder: "Hvad kollekten går til",
    MobilePayNumber: "MobilePay-nummer",
    DefaultMobilePayNumber: "Standard MobilePay-nummer",
    DefaultMobilePayNumberHint:
      "Udfyldes på skabelonens kollekter, når den indlæses i en begivenhed.",
    CopyOfTemplate: "{title} (kopi)",
    CreateScheduleTemplate: "Opret en programskabelon",
    ElementType: "Type",
    Move: "Flyt",
    Slides: "Slides",
    SlidesLibrary: "Bibliotek",
    CreateSlides: "Opret slides",
    EditSlides: "Redigér slides",
    ChooseSlides: "Vælg slides",
    SlidesSelected: "Valgt",
    NoSlideshowsYet:
      "Jeres organisation har ingen slides endnu. Opret et sæt for at tilføje det til programmet.",
    SlideCount: "ingen slides | 1 slide | {count} slides",
    SlideNumber: "Slide {number}",
    AddPhotos: "Tilføj billeder",
    SearchPhotos: "Søg i billeder",
    PhotosHint: "Klik på et billede for at tilføje det som slide.",
    NoPhotosYet:
      "Ingen billeder endnu. Tilføj nogle for at lave slides af dem; de gemmes her, så de kan bruges igen.",
    NoPhotosMatch: "Ingen billeder matcher “{search}”.",
    NoSlidesYet: "Ingen slides endnu. Klik på et billede ovenfor for at tilføje det.",
    SlidesHint: "Træk i et slide for at flytte det.",
    SlideFilesSkipped:
      "Nogle filer kom ikke med: kun billeder på højst 10 MB kan tilføjes.",
    Transition: "Overgang",
    TransitionFade: "Fade",
    TransitionSlide: "Glid",
    TransitionZoom: "Zoom",
    SaveAndAddToSchedule: "Gem og tilføj til programmet",
    UploadingPhotos: "Uploader {done} af {total}",
    FailedToUploadPhotos: "Nogle billeder kunne ikke uploades",
    SlidesSaved: "Slides gemt",
    FailedToSaveSlides: "Kunne ikke gemme slides",
    FailedToLoadSlides: "Kunne ikke indlæse slides",
    FailedToDeleteSlides: "Kunne ikke slette slides",
    FailedToAddSlides: "Kunne ikke tilføje slides til programmet",
    DeleteSlides: "Slet slides",
    DeleteSlidesMessage:
      "Slet “{title}” fra biblioteket? Programpunkter, der viser det, står tilbage uden slides. Billederne beholdes.",
    AddPhotoToSlides: "Tilføj {name} til slides",
    FailedToLoadPhotos: "Kunne ikke indlæse billederne",
    DeletePhoto: "Slet billede",
    DeletePhotoMessage:
      "Slet “{name}” fra jeres billeder? Det kan ikke fortrydes.",
    PhotoInUse:
      "Billedet bruges i {titles} og kan derfor ikke slettes. Fjern det fra de slides først.",
    FailedToDeletePhoto: "Kunne ikke slette billedet",
    AddImageSlides: "Tilføj billedslides",
    ChangeImage: "Skift billede",
    ImageSlidesHint:
      "Klik på billederne for at vælge dem, i den rækkefølge de skal komme.",
    AddSelectedSlides: "Tilføj | Tilføj 1 slide | Tilføj {count} slides",
    OriginalVersion: "Original",
    NewVersion: "Ny version",
    NewVersionDescription:
      "Begynder som en kopi af den version, du har åben. Titel og forfatter deles; tekst, akkorder og afsnit er dens egne.",
    VersionName: "Versionens navn",
    VersionNamePlaceholder: "F.eks. Akustisk",
    SharedByAllVersions: "Titel og forfatter deles af alle versioner.",
    SaveChangesToSwitchVersion: "Gem eller fortryd dine ændringer først",
    ChooseVersion: "Vælg version",
    DeleteVersion: "Slet version",
    ConfirmDeleteVersionDescription:
      "Slet versionen “{name}”? Originalen og eventuelle andre versioner beholdes.",
    DeleteSongVersionsWarning:
      "Sangens andre versioner ({count}) slettes sammen med den.",
  },
};
